import React, {useEffect} from "react";
import { Tabs } from "antd";

const { TabPane } = Tabs;

export default function PrivateExternalData() {

  // useEffect ------------------------------------------------------
  useEffect(() => {
  }, [])

  // render ---------------------------------------------------------
  return (
    <div className="private_page_wrapper">

      <div className="header">
        <span className="title">Données externes</span>
        <span className="subtitle">Imports des données courses ICP, GNET et TDS</span>
      </div>

      <div className="external_data_tabs">
        <Tabs defaultActiveKey="1" size="small" style={{ marginBottom: 32 }}>

          <TabPane tab="OVERVIEW" key="1">
            <p>Date du prochain import</p>
            <p>Fréquence d'import</p>
            <p>liste des imports avec acces au log</p>
          </TabPane>

          <TabPane tab="ICP" key="2">
            <p>btn force import</p>
            <p>liste des tables avec lien affichage liste</p>
            <p>liste de consultation</p>
          </TabPane>

          <TabPane tab="GNET" key="3">
            <p>btn force import</p>
            <p>liste des tables avec lien affichage liste</p>
            <p>liste de consultation</p>
          </TabPane>

          <TabPane tab="TDS" key="4">
            <p>btn force import</p>
            <p>liste des tables avec lien affichage liste</p>
            <p>liste de consultation</p>
          </TabPane>

        </Tabs>
      </div>

    </div>
  )

}